module.exports = __webpack_public_path__ + "img/制御工学5_5_4.7f6a5e23.png";